import React, { Component } from 'react';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { AccountGroupPopup } from './AccountGroupTable';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { CommonValidationMessages } from '../../../utils/Messages';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class AccountGroup extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            accountObject: {
                idAccountGroup: 0,
                accGrpNo: "",
                updateStatus: 0,
                accGrpName: "",
                grpDesc: "",
                remarks: "",
                e_Date: ""
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                // accGrpNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "a"
                //         ),
                //     },
                // ],
                accGrpName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "employee name"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterExpenseAccountGroupSelectbyID(event.data.idAccountGroup);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.accountObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.accountObject;
        details[name] = value;
        this.setState({ accountObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let accountObject = this.state.accountObject;
        accountObject.idAccountGroup = 0;
        accountObject.accGrpNo = "";
        accountObject.updateStatus = 0;
        accountObject.accGrpName = "";
        accountObject.grpDesc = "";
        accountObject.remarks = "";
        accountObject.e_Date = "";
        this.setState({
            accountObject: accountObject, validState: validState
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getMasterExpenseAccGroupCount();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Account Group",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;

                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key,
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idAccountGroup"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Account Group",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                            // this.getAllDropdownForEmployeeMaster();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "accountGroup": window.innerWidth * 0.35,
            "accountGroupDesc": window.innerWidth * 0.2,
            "remarks": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    getMasterExpenseAccGroupCount = () => {
        this.accountMasterServices.getMasterExpenseAccGroupCount(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0].count;
                let accountObject = this.state.accountObject
                accountObject.accGrpNo = data + 1;
                this.setState({
                    accountObject: accountObject
                });
            }
        });
    }

    getMasterExpenseAccountGroupSelectbyID = (id) => {
        this.accountMasterServices.getMasterExpenseAccountGroupSelectbyID(id).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let object = this.state.accountObject
                object.idAccountGroup = data.idAccountGroup;
                object.accGrpNo = data.idAccountGroup;
                object.updateStatus = 1;
                object.accGrpName = data.accountGroup;
                object.grpDesc = data.accountGroupDesc;
                object.remarks = data.remarks;
                object.e_Date = data.e_Date;
                this.setState({
                    isModalOpen: true,
                    accountObject: object
                });
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.accountObject;
            let requestData = {
                idAccountGroup: details.idAccountGroup,
                accountGroup: details.accGrpName,
                accountGroupDesc: details.grpDesc,
                remarks: details.grpDesc,
                idCompany: this.state.idCompany,
                idCompanyDivision: 0,
                e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                isDeleted: false
            };
            this.accountMasterServices.submitAccountGroupMaster(requestData)
                .then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (response.responseItem?.responseContent?.errorType === 'Exists') {
                                this.SwalServices.Error("Account group are already exists");
                            } else {
                                if (this.state.accountObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }

                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    // getMasterBankSelectbyid = (id) => {
    //     this.accountMasterServices.getMasterBankSelectbyid(id).then((response) => {
    //         //debugger
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let bank = this.state.bankMaster;
    //             let responseData = response.responseItem.responseContent[0];

    //             bank.idBank = responseData.idBank;
    //             bank.updateStatus = 1;
    //             bank.idGeneralProduct = responseData.idAccountSubHead;
    //             bank.selectedGeneralProduct = responseData.idAccountSubHead > 0 ? bank.aCCSubHeadList?.find(item => item.value === responseData.idAccountSubHead) : {};
    //             bank.accName = responseData.bankName;
    //             //bank.bankGrp = responseData. ;
    //             bank.openingBalance = responseData.openingBalance;
    //             bank.openingBalanceDate = moment(responseData.opBalanceDate).format('YYYY-MM-DD');
    //             bank.currentBalance = responseData.currentBalance;
    //             bank.selectedbalanceType = responseData.balanceType ? bank.types?.find(item => item.label === responseData.balanceType) : {};;
    //             bank.remarks = responseData.remarks;
    //             bank.e_Date = responseData.e_Date;
    //             // employee.departmentName = responseData.idDepartment > 0 ? employee.departments?.find(item => item.value === responseData.idDepartment)?.label : "";
    //             // employee.selectedDepartment = responseData.idDepartment > 0 ? employee.departments?.find(item => item.value === responseData.idDepartment) : {};
    //             // employee.joiningDate = moment(responseData.joiningDate).format('YYYY-MM-DD');

    //             this.setState({
    //                 bankMaster: bank,
    //                 isModalOpen: true
    //             });
    //         }
    //     });
    // }

    render() {
        return (
            <div className='company-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <AccountGroupPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            accountObject={this.state.accountObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Account group</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}